'use client';

import { useEffect } from 'react';

export default function MarketingScripts({
  campaign_id,
  offer_id,
  lead_type_id,
  lead_type_name,
  lead_score_baseline,
  internal_lead_type_id,
  lead_source_type_name,
}: CampaignType) {
  useEffect(() => {
    import('@/lib/marketing/index').then((Scripts) => {
      Scripts.run({
        campaign_id,
        offer_id,
        lead_type_id,
        lead_type_name,
        lead_score_baseline,
        internal_lead_type_id,
        lead_source_type_name,
      });
    });
  }, [
    campaign_id,
    offer_id,
    lead_type_id,
    lead_type_name,
    lead_score_baseline,
    internal_lead_type_id,
    lead_source_type_name,
  ]);

  return <></>;
}

export type CampaignType = {
  campaign_id: number;
  offer_id: number;
  lead_type_id: number;
  lead_score_baseline: number;
  lead_type_name: string;
  internal_lead_type_id: number;
  lead_source_type_name: string;
};
